var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThrillCashE0872421(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 7.66667H40.668C42.4361 7.66667 44.1318 8.36905 45.382 9.61929C46.6323 10.8695 47.3346 12.5652 47.3346 14.3333V34.3333C47.3346 36.1014 46.6323 37.7971 45.382 39.0474C44.1318 40.2976 42.4361 41 40.668 41H7.33464C5.56653 41 3.87083 40.2976 2.62059 39.0474C1.37035 37.7971 0.667969 36.1014 0.667969 34.3333V7.66667ZM4.0013 1H34.0013C34.8854 1 35.7332 1.35119 36.3583 1.97631C36.9835 2.60143 37.3346 3.44928 37.3346 4.33333V7.66667H0.667969V4.33333C0.667969 3.44928 1.01916 2.60143 1.64428 1.97631C2.2694 1.35119 3.11725 1 4.0013 1V1Z",
    stroke: "#5995C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 27.6667C39.1743 27.6667 40.6667 26.1743 40.6667 24.3333C40.6667 22.4924 39.1743 21 37.3333 21C35.4924 21 34 22.4924 34 24.3333C34 26.1743 35.4924 27.6667 37.3333 27.6667Z",
    fill: "#5995C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrillCashE0872421);
export default __webpack_public_path__ + "static/media/Thrill-Cash-e0872421.51db80142f6729359d3158be621174df.svg";
export { ForwardRef as ReactComponent };